import { getMappedEvents } from '../utils/getMappedEvents';

export const EVENTS = [
  'projectAdvancedToolsOpened',
  'projectAdvancedToolsClosed',
  'uploadSrtFromAdvancedToolsClicked',
  'createDictionaryProjectClick',
  'upgradeDictionaryProjectClick',
  'projectCustomizeTranslationClicked',
] as const;

export const advancedToolsEvents = getMappedEvents([...EVENTS]);
